// extracted by mini-css-extract-plugin
export var divider = "_hx-7";
export var itemsToggle = "_hx-8";
export var mergeModal = "_hx-1";
export var optionCard = "_hx-4";
export var radioGroup = "_hx-6";
export var radioOption = "_hx-0";
export var selected = "_hx-5";
export var shipmentOptions = "_hx-2";
export var tableOptions = "_hx-3";